import {
  useAppSelector,
  useTriggerProductFilterOptionRecount,
} from "@/lib/redux/hooks";
import { ProductFilter } from "@/lib/redux/productFilters/productFiltersSlice";
import { productFilterSelectors } from "@/lib/redux/store";
import { forwardRef, useState } from "react";
import DropdownComponent, { GroupProps } from "./Dropdown/Dropdown";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Dropdown = DropdownComponent as any;

export type AccordionProps = {
  groups: GroupProps[];
};

const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  function Accordion({ groups }) {
    const filterIds = useAppSelector((state) =>
      productFilterSelectors.selectIds(state)?.filter((id) => id !== "catalog")
    );
    const [activeFilter, setActiveFilter] = useState<ProductFilter | null>();
    const triggerRecount = useTriggerProductFilterOptionRecount();

    return (
      <Container>
        {filterIds.map((id) => (
          <Dropdown
            key={id}
            filterId={id}
            isOpen={activeFilter?.id === id}
            groups={groups}
            handleOpen={(filter: ProductFilter) => {
              const nextState = filter.id === activeFilter?.id ? null : filter;
              setActiveFilter(nextState);
              if (nextState) triggerRecount(filter);
            }}
          />
        ))}
      </Container>
    );
  }
);

export default Accordion;
